
import capitalize from 'lodash/capitalize'

export default str => str.split(' ').map(capitalize).join(' ')
